<template>
    <div id="app" :class="vueAppClasses">

        <router-view @setAppClasses="setAppClasses"></router-view>

    </div>
</template>

<script>
import themeConfig from '@/../themeConfig.js'
import jwt         from '@/http/requests/auth/jwt/index.js'
import axios from 'axios';
import qs from 'qs';
export default {
  data () {
    return {
      vueAppClasses: []
    }
  },
  watch: {
    '$store.state.theme' (val) {
      this.toggleClassInBody(val)
    },
    '$vs.rtl' (val) {
      document.documentElement.setAttribute('dir', val ? 'rtl' : 'ltr')
    }
  },
  methods: {
    toggleClassInBody (className) {
      if (className === 'dark') {
        if (document.body.className.match('theme-semi-dark')) document.body.classList.remove('theme-semi-dark')
        document.body.classList.add('theme-dark')
      } else if (className === 'semi-dark') {
        if (document.body.className.match('theme-dark')) document.body.classList.remove('theme-dark')
        document.body.classList.add('theme-semi-dark')
      } else {
        if (document.body.className.match('theme-dark'))      document.body.classList.remove('theme-dark')
        if (document.body.className.match('theme-semi-dark')) document.body.classList.remove('theme-semi-dark')
      }
    },
    setAppClasses (classesStr) {
      this.vueAppClasses.push(classesStr)
    },
    handleWindowResize () {
      this.$store.commit('UPDATE_WINDOW_WIDTH', window.innerWidth)

      // Set --vh property
      document.documentElement.style.setProperty('--vh', `${window.innerHeight * 0.01}px`)
    },
    handleScroll () {
      this.$store.commit('UPDATE_WINDOW_SCROLL_Y', window.scrollY)
    }
  },
  created () {
    this.toggleClassInBody(themeConfig.theme)
    this.$store.commit('UPDATE_WINDOW_WIDTH', window.innerWidth)

    const vh = window.innerHeight * 0.01
    // Then we set the value in the --vh custom property to the root of the document
    document.documentElement.style.setProperty('--vh', `${vh}px`)
  },
  async mounted () {
    var loginData = {
            grant_type: 'password',
            username: 'webservice@yukWSLMMMx8II7yT.com',
            password: 'uPI9T3f5roA*CegiuSwKaxPep82asGLu'
    };
    let expires ;
    if (localStorage.getItem('dx-credentials')) {
        //expires = new Date(JSON.parse(localStorage.getItem("dx-credentials")).expires);
        expires = new Date()-1;
    }else{new Date();};
    //console.log(expires);
    //console.log(new Date());
    if (expires >= new Date()){
      //console.log('süre var');
    }
    else {
      //console.log('süre yok');
    axios({method:'post',url:'https://www.barkodyazilimevi.com.tr/Token',data:qs.stringify(loginData),headers: {'Content-Type': 'application/x-www-form-urlencoded','Access-Control-Allow-Origin': '*' }})
    .then((response) => {//console.log(response); 
    localStorage.setItem('dx-credentials',JSON.stringify({'userName':response.data.userName,'token': response.data.access_token,'expires':response.data[".expires"]}));
    })
    .catch((error) => {console.log(error)});
    }
    // jwt
    jwt.init()

    const dir = this.$vs.rtl ? 'rtl' : 'ltr'
    document.documentElement.setAttribute('dir', dir)

    window.addEventListener('resize', this.handleWindowResize)
    window.addEventListener('scroll', this.handleScroll)

    // Auth0
    //try       { await this.$auth.renewTokens() } catch (e) { console.error(e) }

  },
  destroyed () {
    window.removeEventListener('resize', this.handleWindowResize)
    window.removeEventListener('scroll', this.handleScroll)
  }
}

</script>
